import { render } from "./AvisoLegalPage.vue?vue&type=template&id=490d5486&scoped=true"
import script from "./AvisoLegalPage.vue?vue&type=script&lang=js"
export * from "./AvisoLegalPage.vue?vue&type=script&lang=js"

import "./AvisoLegalPage.vue?vue&type=style&index=0&id=490d5486&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Repository\\C318-CAF. Portal de Juntas telematicas\\CAF-Solution\\NetCoreWebApi\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490d5486"]])

export default __exports__